import { ca } from '@cian/analytics';

export function trackMorePromosClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'click_view_more',
    label: 'more',
    useLastProducts: true,
  });
}
